export * from "./UpdateArticle.async";
